import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-monitored",
  "use": "icon-monitored-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-monitored\"><path d=\"M901.25 261.8l-166.94999999 136.35000001V289.69999999c0-30.59999998-24.75-55.35-55.80000002-55.79999998H178.55c-30.59999998 0-55.35 24.75-55.8 55.80000001v445.04999995c0 30.59999998 24.75 55.35 55.8 55.80000004h500.39999999c30.59999998 0 55.35-24.75 55.80000002-55.8v-108.9l166.95 136.34999999V261.8z\" p-id=\"12347\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol